var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72476 20.2208C6.72476 22.0709 5.21343 23.5822 3.36336 23.5822C1.51328 23.5822 0.00195312 22.0709 0.00195312 20.2208C0.00195312 18.3707 1.51328 16.8594 3.36336 16.8594H6.72476V20.2208Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41992 20.2208C8.41992 18.3707 9.93125 16.8594 11.7813 16.8594C13.6314 16.8594 15.1427 18.3707 15.1427 20.2208V28.6373C15.1427 30.4874 13.6314 31.9987 11.7813 31.9987C9.93125 31.9987 8.41992 30.4874 8.41992 28.6373V20.2208Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7813 6.72329C9.93125 6.72329 8.41992 5.21196 8.41992 3.36189C8.41992 1.51182 9.93125 0.000488281 11.7813 0.000488281C13.6314 0.000488281 15.1427 1.51182 15.1427 3.36189V6.72329H11.7813Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7799 8.41724C13.63 8.41724 15.1413 9.92856 15.1413 11.7786C15.1413 13.6287 13.63 15.14 11.7799 15.14H3.36336C1.51328 15.14 0.00195312 13.6287 0.00195312 11.7786C0.00195312 9.92856 1.51328 8.41724 3.36336 8.41724H11.7799Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2764 11.7786C25.2764 9.92856 26.7877 8.41724 28.6378 8.41724C30.4878 8.41724 31.9992 9.92856 31.9992 11.7786C31.9992 13.6287 30.4878 15.14 28.6378 15.14H25.2764V11.7786Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5851 11.7784C23.5851 13.6285 22.0738 15.1398 20.2237 15.1398C18.3736 15.1398 16.8623 13.6285 16.8623 11.7784V3.36189C16.8623 1.51182 18.3736 0.000488281 20.2237 0.000488281C22.0738 0.000488281 23.5851 1.51182 23.5851 3.36189V11.7784Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2237 25.2761C22.0738 25.2761 23.5851 26.7875 23.5851 28.6375C23.5851 30.4876 22.0738 31.9989 20.2237 31.9989C18.3736 31.9989 16.8623 30.4876 16.8623 28.6375V25.2761H20.2237Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2237 23.5822C18.3736 23.5822 16.8623 22.0709 16.8623 20.2208C16.8623 18.3707 18.3736 16.8594 20.2237 16.8594H28.6402C30.4903 16.8594 32.0016 18.3707 32.0016 20.2208C32.0016 22.0709 30.4903 23.5822 28.6402 23.5822H20.2237Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.f2cb01f221ec1a1b71f5ab4fb7bb3665.svg";
export { ForwardRef as ReactComponent };